export default {
  getAllIndexations: state => state.indexations || [],
};
